import { render, staticRenderFns } from "./Experter.vue?vue&type=template&id=823676e6&scoped=true&"
import script from "./Experter.vue?vue&type=script&lang=js&"
export * from "./Experter.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/expert.css?vue&type=style&index=0&id=823676e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823676e6",
  null
  
)

export default component.exports